import React from "react";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";

const TextCurrencyInput = ({
	label,
	name,
	control,
	errors,
	placeholder,
	onKeyDown,
	autoFocus = false,
	className,
	required = false,
	decimalScale = 2,
	decimalSeparator = ",",
	thousandSeparator = ".",
	prefix = "R$ ",
	allowNegative = false,
	truncate = false,
	onValueChange,
	onValueBlur,
	readOnly = false,
}) => {
	const handleBlur = (rhfOnBlur) => (e) => {
		rhfOnBlur(); // marca como touched no RHF
		if (onValueBlur) {
			onValueBlur(e);
		}
	};

	return (
		<div className={``}>
			{label && (
				<label className={truncate ? `truncate w-48` : ""} htmlFor={name}>
					{label}
				</label>
			)}

			<Controller
				name={name}
				control={control}
				rules={{
					required: required ? "Este campo é obrigatório" : false,
				}}
				render={({ field: { onChange, onBlur, value, ref } }) => {
					if (readOnly) {
						// 👇 Modo somente leitura (exibe valor formatado, não é um input)
						const formatted = new Intl.NumberFormat("pt-BR", {
							style: "currency",
							currency: "BRL",
							minimumFractionDigits: decimalScale,
							maximumFractionDigits: decimalScale,
						}).format(parseFloat(value || 0));

						return <div className={` ${className}`}>{formatted}</div>;
					}

					// 👇 Modo editável
					return (
						<NumericFormat
							value={value}
							onValueChange={(values, sourceInfo) => {
								onChange(values.value);
								onValueChange?.(values.value, sourceInfo);
							}}
							decimalScale={decimalScale}
							decimalSeparator={decimalSeparator}
							thousandSeparator={thousandSeparator}
							prefix={prefix}
							allowNegative={allowNegative}
							fixedDecimalScale={true}
							id={name}
							className={`${errors?.[name] ? "error" : ""} ${className}`}
							placeholder={placeholder}
							onBlur={handleBlur(onBlur)}
							onKeyDown={onKeyDown}
							autoFocus={autoFocus}
						/>
					);
				}}
			/>

			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
		</div>
	);
};

export default TextCurrencyInput;

// import React from "react";
// import { Controller } from "react-hook-form";
// import { NumericFormat } from "react-number-format";

// const TextCurrencyInput = ({
// 	label,
// 	name,
// 	control,
// 	errors,
// 	placeholder,
// 	onKeyDown,
// 	autoFocus = false,
// 	className,
// 	required = false, // Adicione uma prop para required
// 	decimalScale = 2,
// 	decimalSeparator = ",",
// 	thousandSeparator = ".",
// 	prefix = "R$ ",
// 	allowNegative = false,
// 	truncate = false,
// 	onValueChange,
// 	onValueBlur,
// 	readOnly = false,
// }) => {
// 	const handleBlur = (rhfOnBlur) => (e) => {
// 		rhfOnBlur(); // marca como touched no RHF
// 		if (onValueBlur) {
// 			onValueBlur(e); // executa lógica externa, como validar ou recalcular
// 		}
// 	};

// 	return (
// 		<div className={`bg-red-300`}>
// 			<label className={truncate && `truncate w-48`} htmlFor={name}>
// 				{label}
// 			</label>
// 			<Controller
// 				name={name}
// 				control={control}
// 				rules={{
// 					required: required ? "Este campo é obrigatório" : false,
// 				}}
// 				render={({ field: { onChange, onBlur, value, ref } }) => (
// 					<NumericFormat
// 						value={value}
// 						isAllowed={() => !readOnly}
// 						onValueChange={(values, sourceInfo) => {
// 							// if (!readOnly) {
// 							// 	onChange(values.value);
// 							// 	onValueChange?.(values.value, sourceInfo);
// 							// }
// 						}}
// 						readOnly={readOnly} // Permite que o campo seja somente leitura
// 						decimalScale={decimalScale} // Quantidade de casas decimais
// 						decimalSeparator={decimalSeparator} // Separador de decimais
// 						thousandSeparator={thousandSeparator} // Separador de milhares
// 						prefix={prefix} // Prefixo, exemplo: R$
// 						allowNegative={allowNegative} // Permitir números negativos
// 						fixedDecimalScale={true} // Mostra sempre as casas decimais
// 						id={name}
// 						className={errors?.[name] ? "error" : ""}
// 						placeholder={placeholder}
// 						onBlur={handleBlur(onBlur)} // usa handleBlur interno
// 						onKeyDown={onKeyDown}
// 						autoFocus={autoFocus}
// 					/>
// 				)}
// 			/>
// 			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
// 		</div>
// 	);
// };

// export default TextCurrencyInput;
